import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import './organization.css';

export class ActivateUser extends Component {
	constructor(props) {
		super(props);
	}


componentDidUpdate(){
	console.log("Number of Users selected -=-->>>>>>", this.props.usersSelected)
	console.log("Call button active or inactive -=-->>>>>>", this.props.apiCallButtonColor)
}

	render() {
		return (
			<Grid>
				<div className='activateUserContainer'>
					<div className="activateUserHeading">{this.props.buttonStatus}</div>
					<div className='numberOfUser'>
						<h3>users</h3>
		                <div className='lengthOfUser'>{this.props.usersSelected}</div>
					</div>
					<div className={this.props.apiCallButtonColor} onClick={this.props.callAction}>
						{this.props.buttonStatus}
					</div>
				</div>
			</Grid>
		)
	}
}

export default ActivateUser


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/ActivateUser.jsx